import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  fetchCompanyInfo, 
  selectCompanyInfo, 
  selectCompanyLoading 
} from '../app/store/slices/companySlice';

/**
 * Custom hook to get store info with automatic fetching and caching.
 * Data is fetched once and cached in Redux — no duplicate API calls.
 */
export const useStoreInfo = () => {
  const dispatch = useDispatch();
  const storeInfo = useSelector(selectCompanyInfo);
  const loading = useSelector(selectCompanyLoading);

  useEffect(() => {
    // The thunk's condition() guard prevents duplicate calls when data/loading already set
    dispatch(fetchCompanyInfo());
  }, [dispatch]);

  return { storeInfo, loading };
};

// Keep old export for backward compatibility during transition
export const useCompanyInfo = () => {
  const { storeInfo, loading } = useStoreInfo();
  return { companyInfo: storeInfo, loading };
};

export default useStoreInfo;
